import { Button } from '@/components/ui/daisy';
import { PlusIcon } from '@heroicons/react/24/outline';

type TreeAddButtonProps = {
  label: string;
  onClick?: () => void;
};

export default function TreeAddButton({ label, onClick }: TreeAddButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onClick?.();
  };
  return (
    <li>
      <Button
        variant="link"
        size="sm"
        className="w-fit text-base-content font-normal"
        onClick={handleClick}
      >
        <PlusIcon className="h-4 w-4" />
        {label}
      </Button>
    </li>
  );
}
